/** @file lineWidth: a handle line's width this frame in scene units (hover makes it wider). */
import type { GizmoFrame } from './gizmoFrame';
import { GIZMO_METRICS as M } from './gizmoMetrics';
import type { GizmoHandle } from './gizmoShape';

/** `hoverWidth` CSS px on the hovered handle, else `css` (default `ringWidth`), times scene units per CSS px. */
export function lineWidth(f: GizmoFrame, handle: GizmoHandle, css: number = M.ringWidth): number {
  return (f.hover === handle ? M.hoverWidth : css) * f.px;
}
